import {
  InvoicesTemplateStorageFilters
} from '../../components/dashboard/invoices/components/invoices-template/invoices-template.models';
import * as moment from 'moment';
import { deleteEmptyValues } from '@shared';


export function mapTemplateFiltersForApi(form: InvoicesTemplateStorageFilters): any {
  const ewInfo = {
    ...(form.ewInfo ? form.ewInfo : {}),
    ...(form.ewInfo?.DateTimeFrom
      ? {
        DateTimeFrom: moment(form.ewInfo.DateTimeFrom).format('DD.MM.YYYY'),
      }
      : {}),
    ...(form.ewInfo?.DateTimeTo
      ? { DateTimeTo: moment(form.ewInfo.DateTimeTo).format('DD.MM.YYYY') }
      : {}),
  };

  if (ewInfo) {
    deleteEmptyValues(ewInfo);
  }

  return {
    ...(ewInfo ? ewInfo : {}),
  };
}
